// extracted by mini-css-extract-plugin
module.exports = {"waves":"WaveBorder_waves__KC2th","parallax":"WaveBorder_parallax__oAfJB","move-forever":"WaveBorder_move-forever__2B5QX","container":"WaveBorder_container___WaIu"};